import React from "react";

type DocumentSelectionPagePanelProps = {
  bodyView: React.ReactElement;
};

const DocumentSelectionPagePanel: React.FC<DocumentSelectionPagePanelProps> = ({
  bodyView,
}) => (
  <div data-testid="page-documentSelection" data-page-state="ready">
    {bodyView}
  </div>
);

export default DocumentSelectionPagePanel;

